export enum ProductType {
  Unknown = 0,
  Physical = 1,
  Service = 2,
  Activity = 3,
  Request = 4,
  Voucher = 5,
  Ticket = 6,
  Digital = 7,
  Discount = 8,
  Reservation = 9,
  Giftcard = 10,
  ExtraCost = 11,
  /**
   * Retired (PAUL-2844): a subscription ticket is now a Ticket (6) with `is_subscription_ticket`.
   * Kept so stored payloads of the old type still deserialize; the BE refuses it on create/update.
   */
  PrepaidTicket = 12,
  Subscription = 13,
  CombiDeal = 14,
}

export const productTypeTranslations: Record<ProductType, string> = {
  [ProductType.Unknown]: 'global.unknown',
  [ProductType.Physical]: 'global.physical',
  [ProductType.Service]: 'global.service',
  [ProductType.Activity]: 'global.activity',
  [ProductType.Request]: 'global.request',
  [ProductType.Voucher]: 'global.voucher',
  [ProductType.Ticket]: 'global.ticket',
  [ProductType.Digital]: 'global.digital',
  [ProductType.Discount]: 'global.discount',
  [ProductType.Reservation]: 'global.reservation',
  [ProductType.Giftcard]: 'global.giftcard',
  [ProductType.ExtraCost]: 'global.extracost',
  [ProductType.PrepaidTicket]: 'product.form.field.prepaid_ticket',
  [ProductType.Subscription]: 'product.product_type_title.subscription',
  [ProductType.CombiDeal]: 'global.combideal',
};

export const productTypeOptions = [
  { text: productTypeTranslations[ProductType.Unknown], val: ProductType.Unknown },
  { text: productTypeTranslations[ProductType.Physical], val: ProductType.Physical },
  { text: productTypeTranslations[ProductType.Service], val: ProductType.Service },
  { text: productTypeTranslations[ProductType.Activity], val: ProductType.Activity },
  { text: productTypeTranslations[ProductType.Request], val: ProductType.Request },
  { text: productTypeTranslations[ProductType.Voucher], val: ProductType.Voucher },
  { text: productTypeTranslations[ProductType.Ticket], val: ProductType.Ticket },
  { text: productTypeTranslations[ProductType.Digital], val: ProductType.Digital },
  { text: productTypeTranslations[ProductType.Discount], val: ProductType.Discount },
  { text: productTypeTranslations[ProductType.Reservation], val: ProductType.Reservation },
  { text: productTypeTranslations[ProductType.Giftcard], val: ProductType.Giftcard },
  { text: productTypeTranslations[ProductType.ExtraCost], val: ProductType.ExtraCost },
  { text: productTypeTranslations[ProductType.CombiDeal], val: ProductType.CombiDeal },
  { text: productTypeTranslations[ProductType.Subscription], val: ProductType.Subscription },
];
